import {
  Box,
  Paper,
  Toolbar,
  Typography
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { createCaptureFlowTest } from "../../api/flowTests/FlowTest";
import AddFlowTestForm from "../../components/FlowTest/AddFlowTestForm";
import { useTranslationHook } from "../../hooks";
import { useErrorHandler } from "../../hooks/Error/useErrorHandler";
import { setLoading } from "../../store/UI";
import { CreateFlowTestRequest } from "../../types/model/flowTest";

const AddFlowTest = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslationHook();
  const handleError = useErrorHandler();

  const { captureId } = useParams();

  const handleSaveAction = async (values: CreateFlowTestRequest) => {
    try {
      dispatch(setLoading(true));
      const response = await createCaptureFlowTest(Number.parseInt(captureId!), values);
      navigate(`/flow-tests/${response.id}`, { replace: true });
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Box sx={{ width: "100%"}}>
      <Paper sx={{ width: "100%", mb: 2, p: 2}}>
        <Toolbar>
          <Typography sx={{ flex: "1 1 100%"}} variant="h4">
            {t("captures.capture.flow-test.add-new")}
          </Typography>
        </Toolbar>

        <AddFlowTestForm onSubmit={handleSaveAction} />
      </Paper>
    </Box>
  );
};

export default AddFlowTest;